const article = {
    id: 'merged-guideline-team-lead',
    title: 'Team lead on merged shoot guidelines',
    summary: 'Name a team lead when you merge shoot guidelines, and see that name on the merged list.',
    publishedAt: '2026-09-09',
    tags: ['guidelines', 'shoot'],
    sections: [
        {
            type: 'paragraph',
            text: 'Merged shoot guidelines now store a team lead. The name is entered when the merge is created and shows as its own column afterward.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it so the floor knows who owns a merged guideline session.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open the merged shoot guidelines flow from Shoot Preparation.',
                'Create a merge and fill in Team lead along with the name and links.',
                'Save. The Team lead column on the list shows the name you entered.',
            ],
        },
    ],
};

export default article;
